// import Config from '../utilities/Config.js';
// import serialize from '../utilities/serialize.js';
// import closestParent from '../utilities/closestParent.js';

import axios from 'axios'; // @todo do without axios
// import Pristine from '../vendor/pristine.js';

const showStatusMessage = function (element, text, type) {
  const container = element.querySelector('.w-form__messages-container');
  const messages = element.querySelector('.w-form__messages');
  if (messages) {
    messages.classList.remove('w-form__messages--error');
    messages.classList.remove('w-form__messages--success');
    messages.classList.add('w-form__messages--' + type);
    messages.innerHTML = text;
  }
  if (container) {
    container.classList.remove('w-is-hidden');
  }
};
const doError = function (element, response, controller) {
  let messages = [];
  if (response && response.data && response.data.messages) {
    response.data.messages.forEach((message) => {
      messages.push(message.message);
    });
  } else {
    messages.push(controller.config.getVar('form_error_message'));
  }

  if (messages.length === 0) messages.push('error');

  const messageString = messages.join('<br />');
  showStatusMessage(element, messageString, 'error');
};
const setStatus = function (element, status) {
  // console.log(status);
  const button = element.querySelector('button[type="submit"]');
  switch (status) {
    case 'loading':
      element.classList.add('w-is-loading');
      // for (var i = 0; i < element.elements.length; i++) {
      //     element.elements[i].disabled = true;
      // }
      button.disabled = true;

      break;
    case 'idle':
      element.classList.remove('w-is-loading');
      // for (var i = 0; i < element.elements.length; i++) {
      //     element.elements[i].disabled = false;
      // }
      button.disabled = false;

      break;
    case 'done':
      element.classList.add('w-is-done');
      element.classList.remove('w-is-loading');

      const scrollTarget = element.closest('.w-b');
      if (scrollTarget)
        scrollTarget.scrollIntoView({
          behavior: 'smooth',
        });

      break;
  }
};

export default function Form() {
  return {
    init: () => {
      /*
          const inputs = document.querySelectorAll('.w-js-validate');
          inputs.forEach((input) => {
              const error = document.createElement('div');
              error.classList.add('w-form__message');
              input.append(error);

              // Pristine.addValidator(
              //     'max_file_size',
              //     function () {
              //         if (!this.files[0]) {
              //             return true;
              //         }
              //         return !(this.files[0].size > this.maxLength);
              //     },
              //     this.controller.config.getVar('form_validation_messages')[
              //         'max_file_size'
              //     ],
              //     2,
              //     false
              // );
          });
          */
      // Pristine.addMessages(
      //     this.controller.config.getVar('current_language'),
      //     this.controller.config.getVar('form_validation_messages')
      // );
      // Pristine.setLocale(document.documentElement.lang);

      const forms = document.querySelectorAll('[data-w-form]');
      forms.forEach((form) => {
        // const pristine = new Pristine(
        //   form,
        //   {
        //     classTo: 'w-js-validate',
        //     errorClass: 'w-has-error',
        //     successClass: 'w-has-success',
        //     errorTextParent: 'w-form__message',
        //     errorTextTag: 'span',
        //     // errorTextClass: '',
        //   },
        //   true
        // );

        form.addEventListener('submit', (e) => {
          e.preventDefault();

          // const valid = pristine.validate();
          // if (!valid) return;

          setStatus(form, 'loading');

          let method = form.getAttribute('method');
          let url = form.getAttribute('action');

          if (!method) return;
          if (!url) url = document.location.href;

          let formData = new FormData(form);

          axios({
            method,
            url: url,
            data: formData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          })
            .then((response) => {
              if (response && response.data && response.data.success === true) {
                if (response.data.redirect) {
                  document.location.href = response.data.redirect;
                } else {
                  let messages = [];
                  if (response.data.messages) {
                    response.data.messages.forEach((message) => {
                      messages.push(message.message);
                    });
                  } else {
                    messages.push(
                      this.controller.config.getVar('form_success_message')
                    );
                  }
                  if (messages.length === 0) messages.push('success');
                  const messageString = messages.join('<br />');
                  setStatus(form, 'done');
                  showStatusMessage(form, messageString, 'success');
                }
              } else {
                setStatus(form, 'idle');
                doError(form, response, this.controller);
              }
            })
            .catch((response) => {
              setStatus(form, 'idle');
              doError(form, response, this.controller);
            });
        });
      });
    },
  };
}
